import * as React from 'react';

import { useCurrentUser } from '@context/UsersContext';
import { BlockUserMutationAction, useBlockUserMutation } from '@db/Users/Queries';
import { errorAlert } from '@helpers/Alert';

export function useBlockUserAction(userId: string) {
  const { blockedUserIds } = useCurrentUser();
  const contextIsBlocked = blockedUserIds.has(userId);
  const [optimisticBlocked, setOptimisticBlocked] = React.useState<
    { baseIsBlocked: boolean; isBlocked: boolean; userId: string } | undefined
  >();
  const isBlocked =
    optimisticBlocked?.userId === userId && optimisticBlocked.baseIsBlocked === contextIsBlocked
      ? optimisticBlocked.isBlocked
      : contextIsBlocked;
  const blockUserMutation = useBlockUserMutation();

  const onPress = () => {
    if (blockUserMutation.isPending) return;

    blockUserMutation.mutate(
      {
        action: isBlocked ? BlockUserMutationAction.UNBLOCK : BlockUserMutationAction.BLOCK,
        userId,
      },
      {
        onSuccess: (_data, { action }) =>
          setOptimisticBlocked({
            baseIsBlocked: contextIsBlocked,
            isBlocked: action === BlockUserMutationAction.BLOCK,
            userId,
          }),
        onError: (error) => errorAlert(error, { onAction: onPress }),
      }
    );
  };

  return {
    actionLabel: isBlocked ? 'Unblock' : 'Block',
    onPress,
  };
}
